// Returns the numeric breakpoint encoded in body::after content, e.g. "bp-2" -> 2
export function getBreakpoint(defaultIndex = 0) {
    if (typeof window === 'undefined' || !document?.body) return defaultIndex
    try {
        const content = window.getComputedStyle(document.body, ':after').getPropertyValue('content')
        const raw = String(content).replace(/['"]/g, '') // "bp-2" -> bp-2
        const n = parseInt(raw.split('-')[1], 10)
        return Number.isFinite(n) ? n : defaultIndex
    } catch {
        return defaultIndex
    }
}
